import {
  CreateSevenroomsVenueIntegration,
  VenueIntegration,
  VenueIntegrationProduct,
} from '@models/venue/VenueIntegration'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { VENUES_URL } from '@utils/urls'

const getSevenroomsVenueIntegration = (
  venueSlug: string,
  product: VenueIntegrationProduct
) =>
  SBAPI.Fetch<VenueIntegration>(
    `${VENUES_URL}/${venueSlug}/integrations/sevenrooms/${product}`
  )

const saveSevenroomsVenueIntegration = (
  venueSlug: string,
  product: VenueIntegrationProduct,
  data: CreateSevenroomsVenueIntegration
) =>
  SBAPI.Post(
    `${VENUES_URL}/${venueSlug}/integrations/sevenrooms/${product}`,
    data
  )

const getVenueIntegrationTimeSlotsDisplaySetting = (
  venueSlug: string,
  product: VenueIntegrationProduct
) =>
  SBAPI.Fetch<{ displaySlotsNotAttachedToSeatingArea: boolean }>(
    `${VENUES_URL}/${venueSlug}/integrations/sevenrooms/${product}/timeslot-display-setting`
  )

const updateVenueIntegrationTimeSlotsDisplaySetting = (
  venueSlug: string,
  product: VenueIntegrationProduct,
  displaySlotsNotAttachedToSeatingArea: VenueIntegration['displaySlotsNotAttachedToSeatingArea']
) =>
  SBAPI.Put(
    `${VENUES_URL}/${venueSlug}/integrations/sevenrooms/${product}/timeslot-display-setting`,
    {
      displaySlotsNotAttachedToSeatingArea,
    }
  )

export {
  getSevenroomsVenueIntegration,
  getVenueIntegrationTimeSlotsDisplaySetting,
  saveSevenroomsVenueIntegration,
  updateVenueIntegrationTimeSlotsDisplaySetting,
}
